// extracted by mini-css-extract-plugin
export default {"card":"AboutCard_card__SxU0W","about":"AboutCard_about__abIIL","projectDesc":"AboutCard_projectDesc__UwuvU"};